
import classes from './Ball.module.scss'
import clsx from 'clsx'
import { motion } from "framer-motion";

const introVariants = {
    hidden: { opacity: 0 },
    show: {
        opacity: 1,
    }
}

function Ball(props) {

    const { children, degrees, className, specificAngle, heightBall, widthBall, rotateDuration} = props;

    return (
        <motion.div className={classes.ballWrapper} style={{width: widthBall, transform: 'rotate(' + degrees + 'deg) translate( ' + heightBall + 'px) rotate(' + (-degrees) + 'deg)' }}>
            <motion.div variants={introVariants} className={clsx(classes.ball, className)} style={{fontSize: 'min(' + ((widthBall*55)/100) + 'px , 30px )'}} >
                <motion.div animate={{ rotate: -specificAngle }} transition={{ duration: rotateDuration }} >
                    {children}
                </motion.div>
            </motion.div>
        </motion.div>
    )
}

export default Ball